'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { UnstyledButton } from '@s7/base';
import { rem } from '@s7/styles';
import { APP_ITEM_VARIANTS } from './AppItem.contract.js';
import { AppItemIcon } from './AppItemIcon.js';
import { useLinkOverride } from '../../../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getStyles = function(compact) {
    return function(theme) {
        return _extends({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            width: "fit-content"
        }, theme.fn.transition(), theme.fn.focusRing({
            visible: true,
            color: theme.palette.primary.mid
        }), {
            backgroundColor: theme.palette.other.shadow,
            "&:hover": {
                backgroundColor: theme.fn.lighten(theme.palette.other.shadow, 0.025)
            },
            "&:active": {
                backgroundColor: theme.fn.lighten(theme.palette.other.shadow, 0.05),
                transform: "translateY(0.15rem)"
            },
            borderRadius: theme.fn.borderRadius(compact ? "2r" : "1r"),
            padding: compact ? rem("8 8 11 8") : rem("2 4")
        });
    };
};
var AppItem = function(props) {
    var variant = props.variant, compact = props.compact, link = props.link, locale = props.locale, iconProps = props.iconProps, others = _object_without_properties_loose(props, [
        "variant",
        "compact",
        "link",
        "locale",
        "iconProps"
    ]);
    var unpackLink = useLinkOverride();
    if (!APP_ITEM_VARIANTS.includes(variant)) {
        return null;
    }
    return /*#__PURE__*/ jsx(UnstyledButton, _extends({
        as: "a",
        sx: getStyles(compact)
    }, unpackLink(link), others, {
        children: /*#__PURE__*/ jsx(AppItemIcon, _extends({
            compact: compact,
            locale: locale,
            variant: variant
        }, iconProps))
    }));
};

export { AppItem };
